/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export default async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfont-loader" */ "webfontloader");

  webFontLoader.load({
    google: {
      families: ["Rubik:100,300,400,500,700,900", "Fira+Code:400,500,600,700"],
    },
  });
}
